var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ display: _vm.isButtonVisible ? 'block' : 'none' }),attrs:{"id":"goTotop","title":"Go to top"},on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"goo-top-box"},[_c('img',{staticClass:"go-top",attrs:{"src":_vm.$getThemeImagePath('icon-top-arrow.svg')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }